<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-04 16:35:40
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimBalance\components\newTransactions.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-04 18:07:16
-->
<template>
  <normalDialog
    :title="
      $t('label_essweb_ClaimBalance_form_dialog_newClaimTransactionTitle')
    "
    :dialog="show"
    width="700"
    @close="closeDialog"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <AutoComplete
              isRequired
              :items="claimType"
              label="label_essweb_ClaimBalance_form_dialog_claimTypeLabel"
              item-text="claim_type_name"
              item-value="uuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="TransactionsData.claim_type_uuid"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_ClaimBalance_form_dialog_transactionTypeLabel"
              :items="Transactiontype"
              :disabled="!TransactionsData.claim_type_uuid"
              item-text="claim_transaction_type_name"
              item-value="uuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :append-icon="
                TransactionsData.claim_type_uuid ? 'arrow_drop_down' : ''
              "
              v-model="TransactionsData.claim_transaction_type_uuid"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <DateTimePicker
              type="month"
              filled
              :defaultTime="TransactionsData.claim_period"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="
                $t('label_essweb_ClaimBalance_form_dialog_claimPeriodLabel')
              "
              @change="(time) => (TransactionsData.claim_period = time)"
            ></DateTimePicker>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_ClaimBalance_form_dialog_currencyCodeLabel"
              :items="currencyCodes"
              item-text="currency_code"
              item-value="uuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="TransactionsData.currency_uuid"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              v-model="TransactionsData.claim_amount"
              :rules="$GetRules(['_Number_negative'], [null])"
              type="number"
              :label="$t('label_essweb_ClaimBalance_form_dialog_amountLabel')"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              type="date"
              filled
              :defaultTime="TransactionsData.effective_utc_datetime"
              :max="TransactionsData.expired_utc_datetime"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="
                $t(
                  'label_essweb_ClaimBalance_form_dialog_effectiveStartDateLabel'
                )
              "
              @change="
                (time) => (TransactionsData.effective_utc_datetime = time)
              "
            ></DateTimePicker>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              type="date"
              filled
              :defaultTime="TransactionsData.expired_utc_datetime"
              :min="TransactionsData.effective_utc_datetime"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="
                $t('label_essweb_ClaimBalance_form_dialog_expiredDateLabel')
              "
              @change="(time) => (TransactionsData.expired_utc_datetime = time)"
            ></DateTimePicker>
          </v-col>
          <!-- <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_ClaimBalance_form_dialog_timeZoneLabel")
            }}</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              dense
              append-icon="arrow_drop_down"
              single-line
              v-model="TransactionsData.time_zone"
              :placeholder="
                $t('label_essweb_ClaimBalance_form_dialog_timeZoneLabel')
              "
              filled
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-select>
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_ClaimBalance_form_dialog_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              v-model="TransactionsData.remarks"
              dense
              counter="500"
              single-line
              filled
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions newBtn @new="toNew" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";

export default {
  name: "viewClaimTrannsactions",
  props: {
    show: { default: false, type: Boolean },
    curUuid: { default: "", type: [String, Number] },
    staff_uuid: { default: "", type: [String, Number] },
  },
  computed: {
    ...mapGetters(["staticZone", "defaultUTC", "AppInfo"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    claimType() {
      return this.$getSelectTrans(this.claimTypeData, "claim_type_name");
    },
    currencyCodes() {
      return this.$getSelectTrans(this.currencyCodesData, "name");
    },
    Transactiontype() {
      return this.$getSelectTrans(
        this.TransactiontypeData,
        "claim_transaction_type_name"
      );
    },
  },
  data() {
    return {
      claimTypeData: [],
      currencyCodesData: [],
      isEdited: false,
      claimPeriod: [],
      TransactiontypeData: [],
      TransactionsData: {
        claim_type_uuid: "",
        claim_transaction_type_uuid: "",
        currency_uuid: "",
        claim_amount: 0,
        claim_period: "",
        total_amount: 0,
        time_zone: "480",
        effective_utc_datetime: "",
        expired_utc_datetime: "",
        expired_time_zone: "",
        remarks: "",
      },
    };
  },
  watch: {
    show(val) {
      if (!val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.TransactionsData = {
          claim_type_uuid: "",
          claim_transaction_type_uuid: "",
          currency_uuid: "",
          claim_amount: 0,
          claim_period: "",
          total_amount: 0,
          time_zone: 480,
          effective_utc_datetime: "",
          expired_utc_datetime: "",
          expired_time_zone: "",
          remarks: "",
        };
        this.TransactionsData.time_zone = this.defaultUTC;
        this.TransactionsData.expired_time_zone = this.defaultUTC;
        this.TransactionsData.effective_utc_datetime = dayjs(new Date()).format(
          "YYYY-MM-DD"
        );
        this.TransactionsData.claim_period = dayjs(new Date()).format(
          "YYYY-MM"
        );
      }
    },

    "TransactionsData.claim_type_uuid": function (val) {
      if (val) {
        this.getTransactionType(val);
      }
    },
    // "TransactionsData.claim_transaction_type_uuid": function (val) {
    //   let obj = this.TransactiontypeData.find((ele) => ele.uuid === val);
    // },
  },
  mounted() {
    this.TransactionsData.time_zone = this.defaultUTC;
    this.TransactionsData.expired_time_zone = this.defaultUTC;
    this.TransactionsData.effective_utc_datetime = dayjs(new Date()).format(
      "YYYY-MM-DD"
    );
    this.TransactionsData.claim_period = dayjs(new Date()).format("YYYY-MM");

    this.getClaimType();
    this.gteCurrency();
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    gteCurrency: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_form_records",
        url: "/claim/get-claim-currency/",
        data: {
          staff_uuid: that.curAppInfo["user"]["user_id"],
        },
        type: "client",
      }).then((res) => {
        that.currencyCodesData = res.data;
      });
      // 2021-01-18改接口 BJ
      // this.$findPrompt({
      //
      //   prompt_name: "ess_currency_select",

      // }).then((res) => {
      //   that.currencyCodesData = res.data;
      // });
    },
    getClaimType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_claim_claim_type",
        url: "/claim-type/get-claim-type-list/",
      }).then((res) => {
        that.claimTypeData = res.data;
      });
    },
    getTransactionType: function (val) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_transaction_type",
        url: "/claim-transaction-type/get-list/",
        data: { claim_type_uuid: val, add_support_type_filter: 1 },
      }).then((res) => {
        that.TransactiontypeData = res.data;
      });
    },
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      let data = {
        staff_uuid: this.curUuid,
        claim_type_uuid: this.TransactionsData.claim_type_uuid,
        claim_transaction_type_uuid:
          this.TransactionsData.claim_transaction_type_uuid,
        claim_period: dayjs(this.TransactionsData.claim_period).format(
          "YYYYMM"
        ),
        currency_uuid: this.TransactionsData.currency_uuid,
        total_amount: this.TransactionsData.claim_amount,
        effective_utc_datetime: this.$getTimeValue(
          this.TransactionsData.effective_utc_datetime
        ),
        effective_time_zone: this.TransactionsData.time_zone,
        expired_utc_datetime: this.$getTimeValue(
          this.TransactionsData.expired_utc_datetime
        ),
        // expired_time_zone: this.TransactionsData.time_zone,//BJ
        remarks: this.TransactionsData.remarks,
      };

      this.$emit("onNew", data);
    },
  },
};
</script>
